export const normalizeApiBaseUrl = (value: string) => value.replace(/\/+$/, '');
